import { useRouter } from 'next/router';

import { AUTH_ROUTE } from '@shared/v2/utils/oauth';

import { Member } from '../../types';

type MemberDetails = Member | null | undefined;

type UseInitialiseMemberDetailsOptions = {
  memberDetails: MemberDetails;
  setMemberDetails: (member: MemberDetails) => void;
  syncMemberDetails: () => void;
};

// Automatically syncs AuthProvider's memberDetails once, with `/api/member-details`
export const useInitialiseMemberDetails = ({
  memberDetails,
  setMemberDetails,
  syncMemberDetails,
}: UseInitialiseMemberDetailsOptions) => {
  const { asPath } = useRouter();

  const hasMemberDetailsInitialised = memberDetails !== undefined;

  if (hasMemberDetailsInitialised) return;

  if (asPath.startsWith(AUTH_ROUTE)) {
    setMemberDetails(null);
    return;
  }

  syncMemberDetails();
};
